module.exports = __webpack_public_path__ + "img/galleria2.8b88ba97.jpg";